import { APPLICATION_COLORS } from '@config/colors';
import { z } from 'zod';

/**
 * @description Sport::Lap intensity_classification properties
 * @see ConstantsService::SPORT_LAP__INTENSITY_CLASSIFICATIONS
 */

export enum SPORT_LAP_INTENSITY_CLASSIFICATIONS {
  UNDEFINED = 'undefined',
  LIT = 'lit',
  THR = 'thr',
  HIT = 'hit',
  UNCLASSIFIED = 'unclassified',
}

export const SportLapIntensityClassificationSchema = z.nativeEnum(SPORT_LAP_INTENSITY_CLASSIFICATIONS);

export function color_namespace_by_sport_lap_intensity_classification(
  intensity_classification: SPORT_LAP_INTENSITY_CLASSIFICATIONS
) {
  switch (intensity_classification) {
    case SPORT_LAP_INTENSITY_CLASSIFICATIONS.HIT:
      return APPLICATION_COLORS.red;
    case SPORT_LAP_INTENSITY_CLASSIFICATIONS.THR:
      return APPLICATION_COLORS.yellow;
    case SPORT_LAP_INTENSITY_CLASSIFICATIONS.LIT:
      return APPLICATION_COLORS.green;
    case SPORT_LAP_INTENSITY_CLASSIFICATIONS.UNCLASSIFIED:
      return APPLICATION_COLORS.anthracite;
    case SPORT_LAP_INTENSITY_CLASSIFICATIONS.UNDEFINED:
      return APPLICATION_COLORS.neutral;
  }
}

export function color_namespace_key_by_sport_lap_intensity_classification(
  intensity_classification: SPORT_LAP_INTENSITY_CLASSIFICATIONS
): keyof typeof APPLICATION_COLORS {
  switch (intensity_classification) {
    case SPORT_LAP_INTENSITY_CLASSIFICATIONS.HIT:
      return 'red';
    case SPORT_LAP_INTENSITY_CLASSIFICATIONS.THR:
      return 'yellow';
    case SPORT_LAP_INTENSITY_CLASSIFICATIONS.LIT:
      return 'green';
    case SPORT_LAP_INTENSITY_CLASSIFICATIONS.UNCLASSIFIED:
      return 'anthracite';
    case SPORT_LAP_INTENSITY_CLASSIFICATIONS.UNDEFINED:
      return 'neutral';
  }
}
